import React, { useState, forwardRef, useImperativeHandle } from 'react';
// import OutsideClickHandler from '@/shared/OutsideClickHandler'
import Checkbox from '@/ui/checkbox/Checkbox';
import s from './dropdown-multiple.module.css';

// eslint-disable-next-line react/display-name
const DropdownMultiple = forwardRef(({ options, onChange, add, forArray, placeholder }, ref) => {
	const [isOpen, setIsOpen] = useState(false);
	const [lastTimeToggled, setLastTimeToggled] = useState(new Date());

	const toggleModal = (value, priority = false) => {
		// console.log("toggled", value);
		const d = new Date();
		if (priority || d - lastTimeToggled > 80) {
			setLastTimeToggled(d);
			setIsOpen(value);
		}
	};

	useImperativeHandle(ref, () => ({
		parentToggleModal(value, priority) {
			// console.log('edo check', value)
			toggleModal(value, priority);
		},
	}));

	return isOpen ? (
		<div className={s.overlay}>
			{/* {!isOpen && <div>open</div>} */}

			<div className={s.labelsContainer}>
				<div key='Όλα' className={s.labelContainer} onClick={() => add(forArray, true)}>
					<div className={s.item}>Όλα</div>
				</div>

				<div key='Αφαίρεση' className={s.labelContainer} onClick={() => add(forArray, false)}>
					<div className={s.item}>Αφαίρεση</div>
				</div>
			</div>

			{options.map((o, idx) => (
				// console.log('oooo', o) ||
				<div key={o.value} className={s.itemContainer} onClick={() => onChange(idx)}>
					<Checkbox
						// onChange={() => onChangeDelivery(it.id)}
						checked={o.checked}
						// disabled={allSelectedDeliveriesSelected}
					/>
					<div className={s.item}>{o.label}</div>
				</div>
			))}
		</div>
	) : null;
});

export default DropdownMultiple;
